import axios from "axios";
import { Constants } from "../utils/Constants";

export function getChatData(uuid, token) {
    return axios.get(`${Constants.url}/chat/${uuid}`, { headers: { Authorization: token } });
}

export function sendChatMessage(uuid, payload, token) {
    return axios.post(`${Constants.url}/chat/${uuid}`, payload, { headers: { Authorization: token } });
}

export function getLatestChatMessages(uuid, uuidChat, token, offsetId) {
    return axios.get(`${Constants.url}/chat/${uuid}/messages/${uuidChat}/${offsetId}`, { headers: { Authorization: token } });
}

export async function sendChatMessageStream(uuid, payload, token, onData, onFinish, onError) {
    try {
        const response = await fetch(`${Constants.url}/chat/${uuid}`, {
            method: "POST",
            headers: { Authorization: token, "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        if (response.status !== 200) {
            const { value } = await reader.read();
            const chunk = decoder.decode(value, { stream: true });
            const error = JSON.parse(chunk);
            throw error.errors?.[0];
        }

        let buffer = "";

        while (true) {
            const { done, value } = await reader.read();

            if (done) {
                break;
            }

            const chunk = decoder.decode(value, { stream: true });
            buffer += chunk;
            const parts = buffer.split("\n\n");

            for (const eventBlock of parts) {
                if (!eventBlock.trim()) continue;

                const lines = eventBlock.split("\n");
                let eventType = "message"; // default
                let data = "";

                for (const line of lines) {
                    if (line.startsWith("event:")) {
                        eventType = line.replace("event:", "").trim();
                    } else if (line.startsWith("data:")) {
                        data += line.replace("data:", "").trim();
                    }
                }

                try {
                    const { value } = JSON.parse(data);

                    if (eventType === "message") {
                        onData(value);
                    } else if (eventType === "end") {
                        onFinish(value);
                    } else if (eventType === "error") {
                        onError(value);
                    }
                } catch (err) {
                    throw new Error("Erro ao ler resposta");
                }
            }

            buffer = parts[parts.length - 1];
        }
    } catch (err) {
        onError(typeof err === "string" ? err : "Erro ao enviar mensagem");
    }
}
